import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { credentialSelector } from '../../../reducers/credential';
import { apiRequest } from '../../../APIClient';
import {
  featureFlagSelector,
  sessionSelector,
} from '../../../reducers/session';

export const useFetchSubscriptionsOnMount = () => {
  const isListCloudAppsEnabled = useSelector(
    featureFlagSelector.credentials.listCloudApps,
  );
  const hasFetched = useSelector(credentialSelector.hasFetchedSubscriptions);
  const customerId = useSelector(sessionSelector.getCustomerID);

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (!hasFetched && isListCloudAppsEnabled) {
      dispatch(apiRequest.getSubscriptions(customerId));
    }
  }, [dispatch, customerId, hasFetched, isListCloudAppsEnabled]);
};
